<template>
  <div class="tableWithPerPageSelection">
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()" class="column is-narrow">
            <b-input
              :placeholder="$t('general.button.search')"
              type="search"
              icon="magnify"
              v-model="criteresRecherche.auto"
            >
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click="setShowFiltre">
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7"
                >{{ $t("general.button.filtre") }}
                <label
                  class="has-text-weight-bold"
                  :class="nombreCritere > 0 ? '' : 'is-invisible'"
                >
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span
              @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer"
            >
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton :perm="permTiers.exporter" :query="exportExcelQuery" />
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="finChargement = true"
        >
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="finChargement && mountedLoadingEnd"
    >
      <template slot="afterTable">
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"
        />
      </template>
     <template slot="produit.reference" slot-scope="props">
        <router-link-blank
          v-if="props.row.typeProduit"
          :to="{ name: getLibelleAndRouteProduit(props.row).routeDetail,
          params: { id: props.row.produit.id }}"
          :message="props.row.produit.reference">
        </router-link-blank>
     </template>
     <template slot="libelle" slot-scope="props">
        {{ props.row.libelle }}
     </template>
     <template slot="format" slot-scope="props">
      {{ getFormat(props.row) }}
     </template>
     <template slot="codePostal" slot-scope="props">
      {{ getProduitAdresse(props.row).codePostal }}
    </template>
    <template slot="adresse" slot-scope="props">
      {{ getAdresseFormatted(getProduitAdresse(props.row)) }}
    </template>
    <template slot="ville" slot-scope="props">
      {{ getProduitAdresse(props.row).ville }}
    </template>
     <template slot="dateDevisCommande" slot-scope="props">
        {{ formatDate(props.row.devisCommande.dateDevisCommande) }}
     </template>
     <template slot="dateDebut" slot-scope="props">
        {{ formatDate(props.row.dateDebut ) }}
     </template>
     <template slot="dateFin" slot-scope="props">
        {{ formatDate(props.row.dateFin ) }}
     </template>
     <template slot="totalHtAvecLigneRemise" slot-scope="props">
        <span class="is-pulled-right">
          {{ formatDevise(props.row.totalHtAvecLigneRemise) }}
        </span>
     </template>
     <template slot="devisCommande.code" slot-scope="props">
        <router-link-blank
          :to="getDetailRoute(props.row)"
          :message="props.row.devisCommande.code">
        </router-link-blank>
     </template>
    <template slot="devisCommande.commercialId" slot-scope="props">
      {{ getNameCommercial(props.row.devisCommande.commercialId) }}
    </template>
    <template slot="etat" slot-scope="props">
      {{ getEtat(props.row.devisCommande.etat)}}
    </template>
    <template slot="devisCommande.dateDevisCommande" slot-scope="props">
      {{ formatDate(props.row.devisCommande.dateDevisCommande) }}
    </template>
    <template slot="nomCommercial" slot-scope="props">
     {{ getNomCommercialIntervenants(props.row) }}
    </template>
    <template slot="typeProduit" slot-scope="props">
      {{ getLibelleCategorieProduit(props.row.typeProduit) }}
    </template>
    </v-server-table>
    <transition
      name="custom-classes-transition"
      enter-active-class="animate__animated animate__slideInRight"
      leave-active-class="animate__animated animate__slideOutRight"
      :duration="10"
    >
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-ventes
          ref="filtreComponent"
          @toggleFiltre="setShowFiltre"
          @recherche="makeRechercheFilter"
          :nameStore="nameStore"
          :type="type"
        />
      </div>
    </transition>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { TIERS } from '@/configuration/permissionsBodacConf';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import parametrageTable from '@/components/general/parametrageTable';
import filtreListeVentes from '@/components/clients/clients/ventes/filtreListeVentes';
import messageErreur from '@/services/general/messageErreur';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import critereRechercheBaseDevis from '@/services/ligneCommande/critereRechercheBaseDevis';
import critereRechercheBaseFacture from '@/services/ligneCommande/critereRechercheBaseFacture';
import critereRechercheBaseVentes from '@/services/ligneCommande/critereRechercheBaseVentes';
import { CATEGORIE_PRODUIT } from '@/configuration/catalogue/produitConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import formatDate from '@/services/general/formatDate';
import formatIsoDate from '@/services/general/formatIsoDate';
import { formatDevise } from '@/services/general/filters/formatDevise';
import { getWithLiensInferieurs } from '@/api/tiers/index';
import * as produitConf from '@/configuration/catalogue/produitConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { columnsSplice } from '@/services/general/columns';
import { TYPOLOGIE_AUCUN, TYPOLOGIE_POINT_DE_VENTE } from '@/configuration/tiers/tiersConf';
import {
  TYPE_DEVIS,
  TYPE_COMMANDE,
  TYPE_FACTURE,
  DEVIS_ETAT,
  COMMANDE_ETAT,
} from '@/configuration/devisConf';
import { FACTURE_ETAT } from '@/configuration/facture/factureConf';
import {
  REFERENCE_TABLE_VENTES,
  REFERENCE_TABLE_DEVIS_CLIENT,
  REFERENCE_TABLE_FACTURE_CLIENT,
} from '@/configuration/general/referenceTableConf';
import cloneDeep from 'lodash/cloneDeep';

const societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'LigneCommandeClient',
  components: {
    routerLinkBlank,
    exportExcelButton,
    TableItemsInView,
    parametrageTable,
    filtreListeVentes,
  },
  props: {
    tiersId: {
      type: String,
      required: true,
    },
    tiersInformation: {
      type: Object,
      required: true,
    },
    nameStore: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
      validator: (value) => [TYPE_DEVIS, TYPE_FACTURE, TYPE_COMMANDE].includes(value),
    },
  },
  data() {
    return {
      loadingComponent: null,
      permTiers: TIERS,
      showFiltre: false,
      finChargement: false,
      mountedLoadingEnd: false,
      resultPerPage: RESULTS_PER_PAGE,
      formatDate,
      formatDevise,
      TYPE_DEVIS,
      TYPE_FACTURE,
      TYPE_COMMANDE,
      targetTiersIds: [],
    };
  },

  computed: {
    criteresRecherche: {
      get() {
        return this.$store.getters[`${this.nameStore}/criteresRechercheVentes`];
      },
      set(value) {
        this.$store.commit(`${this.nameStore}/SET_CRITERE_VENTES`, value);
      },
    },
    items() {
      return this.$store.getters[`${this.nameStore}/items`];
    },
    lastPayload() {
      return this.$store.getters[`${this.nameStore}/lastPayload`];
    },
    totalCount() {
      return this.$store.getters[`${this.nameStore}/totalCount`];
    },
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    isPointDeVenteOrAucun() {
      return [TYPOLOGIE_POINT_DE_VENTE, TYPOLOGIE_AUCUN].includes(this.tiersInformation.typologie);
    },
    referenceTable() {
      switch (this.type) {
        case TYPE_DEVIS:
          return REFERENCE_TABLE_DEVIS_CLIENT;
        case TYPE_FACTURE:
          return REFERENCE_TABLE_FACTURE_CLIENT;
        default:
          return REFERENCE_TABLE_VENTES;
      }
    },
    columns() {
      const columns = ['devisCommande.code', 'devisCommande.dateDevisCommande', 'devisCommande.commercialId', 'produit.reference', 'libelle', 'nomCommercial', 'adresse', 'codePostal', 'ville', 'format', 'dateDebut', 'dateFin', 'etat', 'totalHtAvecLigneRemise', 'typeProduit'];
      if (this.isPointDeVenteOrAucun) columnsSplice(columns, 'nomCommercial');
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          'produit.reference': this.$i18n.t('listeVentesForClient.tabs.reference'),
          libelle: this.$i18n.t('listeVentesForClient.tabs.libelle'),
          'devisCommande.code': this.getCodeCommandeLabel(),
          etat: this.getEtatLabel(),
          'devisCommande.dateDevisCommande': this.getDateCommandeLabel(),
          'devisCommande.commercialId': this.$i18n.t('listeVentesForClient.tabs.commercial'),
          nomCommercial: this.$i18n.t('listeVentesForClient.tabs.nomCommercial'),
          adresse: this.$i18n.t('listeVentesForClient.tabs.adresse'),
          codePostal: this.$i18n.t('listeVentesForClient.tabs.codePostal'),
          ville: this.$i18n.t('listeVentesForClient.tabs.ville'),
          dateDebut: this.$i18n.t('listeVentesForClient.tabs.dateDebutLoc'),
          dateFin: this.$i18n.t('listeVentesForClient.tabs.dateFinLoc'),
          totalHtAvecLigneRemise: this.$i18n.t('listeVentesForClient.tabs.montant'),
          typeProduit: this.$t('listeLignesDevis.tabs.typeProduit'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: (data) => {
          data.query = cloneDeep(this.criteresRecherche);
          if (!data.orderBy) {
            data.ascending = 0;
            data.orderBy = 'devisCommande.dateDevisCommande';
          }
          data.query.tiersId = this.targetTiersIds;
          data.query.societeId = this.societeActiveId;

          if (data.query.typesProduits && Array.isArray(data.query.typesProduits)) {
            data.query.typesProduits = data.query.typesProduits.map(item => (typeof item === 'object' ? item.code : item));
          }

          if (data.query.datesEtVenteDivers.dateDebut) {
            data.query.datesEtVenteDivers.dateDebut = formatIsoDate(
              data.query.datesEtVenteDivers.dateDebut,
            );
          }
          if (data.query.datesEtVenteDivers.dateFin) {
            data.query.datesEtVenteDivers.dateFin = formatIsoDate(
              data.query.datesEtVenteDivers.dateFin,
            );
          }
          if (this.type === TYPE_DEVIS) {
            critereRechercheBaseDevis(data.query);
          } else if (this.type === TYPE_FACTURE) {
            critereRechercheBaseFacture(data.query);
          } else if (this.type === TYPE_COMMANDE) {
            critereRechercheBaseVentes(data.query);
          }
          return this.loadLignesCommande(data);
        },
        responseAdapter: () => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        },
        sortable: ['libelle', 'produit.reference', 'dateDebut', 'dateFin', 'devisCommande.code', 'devisCommande.commercialId', 'totalHtAvecLigneRemise', 'devisCommande.dateDevisCommande'],
      };
    },
    nombreCritere() {
      const banCritere = [
        'auto',
        'types',
        'tiersId',
        'typesDevisCommandeFacture',
        'datesEtVenteDivers',
        'etatsDevisCommandeFacture',
        'dateVisualisation',
        'sens',
        'agencesId',
        'societeId',
        'typeDevisCommande',
      ];
      return calculNombreCritere(this.criteresRecherche, banCritere);
    },
    exportExcelQuery() {
      return {
        typeDonnee: 'lignecommandeventes',
        typeExport: null,
        filtres: this.lastPayload,
        parametresAdditionnels: {
          withAllClients: !this.isPointDeVenteOrAucun,
        },
      };
    },
    users() {
      return this.parametre(PARAMETRES_KEYS.utilisateur) ?? [];
    },
  },
  methods: {
    loadLignesCommande(data) {
      return this.$store.dispatch(`${this.nameStore}/loadLigneCommande`, data);
    },
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getLibelleCategorieProduit(typeProduit) {
      const type = CATEGORIE_PRODUIT.find((t) => t.code === typeProduit);
      return type ? this.$t(type.libelle) : null;
    },
    getDetailRoute(row) {
      if (this.type === TYPE_FACTURE) {
        return {
          name: 'c.bodac.factures',
          params: { id: row.devisCommande.id },
        };
      }
      if (this.type === TYPE_DEVIS) {
        return {
          name: 'c.bodac.devis',
          params: { id: row.devisCommande.id },
        };
      }
      return {
        name: 'c.bodac.commandes',
        params: { id: row.devisCommande.id },
      };
    },
    getNameCommercial(commercialId) {
      return this.users?.find((user) => {
        return user.id === commercialId;
      })?.decorator?.nomPrenom ?? '';
    },
    getNomCommercialIntervenants(row) {
      return row.devisCommande?.intervenants?.map(i => i.nomCommercial)?.join(', ') ?? '';
    },
    getLibelleAndRouteProduit(ligne) {
      const produitConfiguration = CATEGORIE_PRODUIT.find(
        (produitObject) => produitObject.code === ligne.typeProduit,
      );
      if (ligne.typeProduit) return produitConfiguration;
      return { libelle: this.$t('catalogue.type.divers'), routeDetail: '' };
    },
    getEtat(etatLigne) {
      let etats = [];
      switch (this.type) {
        case TYPE_DEVIS: etats = DEVIS_ETAT; break;
        case TYPE_COMMANDE: etats = COMMANDE_ETAT; break;
        case TYPE_FACTURE: etats = FACTURE_ETAT; break;
        default: etats = [];
      }
      const etatFind = etats.find((etat) => {
        return etat.code === etatLigne;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : '';
    },
    getCodeCommandeLabel() {
      if (this.type === TYPE_DEVIS) {
        return this.$t('listeVentesForClient.tabs.codeDevis');
      } if (this.type === TYPE_FACTURE) {
        return this.$t('listeVentesForClient.tabs.codeFacture');
      }
      return this.$i18n.t('listeVentesForClient.tabs.codeCommande');
    },
    getEtatLabel() {
      if (this.type === TYPE_DEVIS) {
        return this.$t('listeVentesForClient.tabs.etatDevis');
      } if (this.type === TYPE_FACTURE) {
        return this.$t('listeVentesForClient.tabs.etatFacture');
      }
      return this.$i18n.t('listeVentesForClient.tabs.etatCommande');
    },
    getDateCommandeLabel() {
      if (this.type === TYPE_DEVIS) {
        return this.$t('listeVentesForClient.tabs.dateDevis');
      } if (this.type === TYPE_FACTURE) {
        return this.$t('listeVentesForClient.tabs.dateFacture');
      }
      return this.$i18n.t('listeVentesForClient.tabs.dateCommande');
    },
    async getAllTiersIds() {
      const lien = (await getWithLiensInferieurs(this.tiersId, true)).data.result;
      const ids = [lien.id];
      if (lien.tiersEnfants?.length > 0) {
        ids.push(lien.tiersEnfants.map(te => {
          if (te.tiersEnfants?.length > 0) {
            return [te.id, te.tiersEnfants.map(tee => tee.id)];
          }
          return [te.id];
        }));
      }
      return ids.flat(3);
    },
    getFormatLibelle(id) {
      const formatFind = this.parametre(PARAMETRES_KEYS.format).find((format) => {
        return format.id === id;
      });
      return formatFind ? formatFind.libelle : null;
    },
    getFormat(ligne) {
      switch (ligne.typeProduit) {
        case produitConf.CATEGORIE_REGROUPEMENT:
        case produitConf.CATEGORIE_REGROUPEMENT_LC:
          return this.getFormatLibelle(ligne.produit.produitReseau.formatId);
        case produitConf.CATEGORIE_UNITAIRE:
          return ligne.produit.produitFace.format;
        case produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE:
          return this.getFormatLibelle(ligne.produit.produitReseauNumerique.formatId);
        case produitConf.CATEGORIE_ECRAN_NUMERIQUE:
          return ligne.produit.produitEcranNumerique.format;
        default:
          return '';
      }
    },
    getProduitAdresse(ligne) {
      switch (ligne.typeProduit) {
        case produitConf.CATEGORIE_REGROUPEMENT:
        case produitConf.CATEGORIE_REGROUPEMENT_LC:
          return ligne.produit.produitReseau.adresse;
        case produitConf.CATEGORIE_UNITAIRE:
          return ligne.produit.produitFace.adresse;
        case produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE:
          return ligne.produit.produitReseauNumerique.adresse;
        case produitConf.CATEGORIE_ECRAN_NUMERIQUE:
          return ligne.produit.produitEcranNumerique.adresse;
        default:
          return {};
      }
    },
    getAdresseFormatted(adresse) {
      return adressFullStringGetter(adresse, true);
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) {
        await this.$refs.filtreComponent.initializeFiltre();
      }
    },

    makeRechercheFilter() {
      this.setShowFiltre();
      this.recherche();
    },
    finLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable]?.refresh();
    },
    async reinitialiser() {
      await this.$refs.filtreComponent.initializeFiltre();
      this.$refs.filtreComponent.viderCritere();
      this.$refs.filtreComponent.appliquerCritere();
      this.showFiltre = false;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      await this.loadParametres([PARAMETRES_KEYS.format]);
      this.targetTiersIds = await this.getAllTiersIds();
      await this.reinitialiser();
      this.mountedLoadingEnd = true;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>

<style scoped>
.mgt-20px {
  margin-top: 20px;
}
</style>
